/**
 * tourSteps/kanbanSteps.js
 * Comprehensive tour steps for the Agile Kanban Board view.
 */

export const kanbanSteps = [
    {
        title: 'Agile Kanban Workspace',
        description: 'Visualize your team\'s workflow dynamically across stages. Drag and drop work items to update progress in real time with automated database and timer sync.',
        selector: '[data-tour="kanban-board"]',
        placement: 'top',
    },
    {
        title: 'Status Lanes & Workflow Stages',
        description: 'Categorized into distinct execution columns: Backlog, In Progress, Under Review, and Completed. Each column displays a live item count badge and color-coded accent bar.',
        selector: '[data-tour="kanban-columns"]',
        fallbackSelector: '[data-tour="kanban-board"]',
        placement: 'bottom',
    },
    {
        title: 'Quick Task Creation Per Column',
        description: 'Click the "+" button on any column header to quickly create a new task with that specific status already preselected.',
        selector: '[data-tour="kanban-add-card-btn"]',
        fallbackSelector: '[data-tour="kanban-board"]',
        placement: 'bottom',
    },
    {
        title: 'Interactive Kanban Cards',
        description: 'Each card summarizes task essentials: Title, Task ID, Priority badge, Assignee avatar, Due date countdown, and Effort logged vs Estimated hours.',
        selector: '[data-tour="kanban-card"]',
        fallbackSelector: '[data-tour="kanban-board"]',
        placement: 'bottom',
    },
    {
        title: 'Drag & Drop Progression',
        description: 'Move cards between lanes seamlessly. Dropping a task into "Completed" automatically prompts deliverable validation for milestones or marks tasks ready for review.',
        selector: '[data-tour="kanban-board"]',
        placement: 'top',
    },
];
